import { cn } from '@/utils/styles/cn'

/**
 * lp-v3 section heading — two centred lines. The first line is the body face (Replica LL), the second
 * is the NeueBit pixel display face in brand orange. Matches the Figma "section heading" style:
 * line 1 = L (40 / 110), line 2 = NeueBit Bold (55 / 81). Sizes scale down on mobile. `!` beats the
 * `.ds2` element typography that still wraps the shell.
 */
export function LpSectionHeading({ line1, line2, className }: { line1: string; line2: string; className?: string }) {
    return (
        <h2 className={cn('text-center', className)}>
            <span className="block text-[28px]! font-normal leading-[1.1]! tracking-normal! text-foreground md:text-[40px]!">
                {line1}
            </span>
            <span className="mt-1 block font-[family-name:var(--font-landing-pixel)]! text-[28px]! font-bold leading-[1]! tracking-normal! text-[#FF5500]! md:text-[40px]!">
                {line2}
            </span>
        </h2>
    )
}
